"use strict";

var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _assertThisInitialized = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
require("./MiniMap.scss");
var CanvasAlignmentComponent_1 = require("./CanvasAlignmentComponent");
var css_element_queries_1 = require("css-element-queries");
var MiniMapComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MiniMapComponent, _React$Component);
  function MiniMapComponent(props) {
    var _this;
    _classCallCheck(this, MiniMapComponent);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MiniMapComponent).call(this, props));
    /*
     *
     *
     * RENDER METHODS
     *
     *
     */
    _this.renderCanvasComponent = function () {
      var _this$props = _this.props,
        alignment = _this$props.alignment,
        highlightRows = _this$props.highlightRows,
        sortBy = _this$props.sortBy,
        alignmentStyle = _this$props.alignmentStyle;
      var size = _this.getSizing();
      return React.createElement(CanvasAlignmentComponent_1.CanvasAlignmentComponent, {
        alignment: alignment,
        alignmentType: alignmentStyle.alignmentType,
        positionsToStyle: alignmentStyle.positionsToStyle,
        colorScheme: alignmentStyle.colorScheme,
        sortBy: sortBy,
        stageDimensions: {
          width: size.frameWidth - 14,
          height: size.frameHeight
        },
        highlightRows: highlightRows,
        onClick: _this.props.onClick,
        onIndicatorDrag: _this.props.onIndicatorDrag
      });
    };
    _this.state = {
      //zoomPercent: 1,
      height: window.innerHeight
    };
    _this.setupResizeSensor = _this.setupResizeSensor.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(MiniMapComponent, [{
    key: "getSizing",
    value: function getSizing() {
      var startingWidth = this.props.startingWidth;
      var _this$state = this.state,
        height = _this$state.height,
        resizedWidth = _this$state.resizedWidth;
      var frameBorderWidth = 1; // in pixels
      var frameMargin = 2; // in pixels
      function adjustForBorderAndMargin(length) {
        return length - 2 * frameMargin - 1 * frameBorderWidth;
      }
      return {
        borderWidth: frameBorderWidth,
        margin: frameMargin,
        frameHeight: height,
        frameWidth: resizedWidth ? resizedWidth : startingWidth ? adjustForBorderAndMargin(startingWidth) : adjustForBorderAndMargin(MiniMapComponent.defaultProps.startingWidth)
      };
    }
  }, {
    key: "setupResizeSensor",
    value: function setupResizeSensor(ref) {
      var _this2 = this;
      if (ref && !this.resizeSensor) {
        this.ref = ref;
        this.resizeSensor = new css_element_queries_1.ResizeSensor(ref, function () {
          if (_this2.state.resizedWidth !== ref.clientWidth || _this2.state.height !== ref.clientHeight) {
            setTimeout(function () {
              //flashes (worse) without setTimeout. Safari still flashing.
              _this2.setState({
                resizedWidth: ref.clientWidth,
                height: ref.clientHeight
              });
            });
          }
        });
      }
    }
    /*
     *
     *
     * REACT METHODS
     *
     *
     */
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        alignHorizontal = _this$props2.alignHorizontal,
        resizable = _this$props2.resizable,
        verticalHeight = _this$props2.verticalHeight;
      var size = this.getSizing();
      var position = verticalHeight === "div" ? "absolute" : "fixed";
      return React.createElement("div", {
        ref: this.setupResizeSensor,
        className: "minimap-holder",
        style: Object.assign(Object.assign({}, alignHorizontal === "left" ? {
          left: 0
        } : {
          right: 0
        }), {
          position: position,
          width: size.frameWidth,
          borderWidth: "".concat(size.borderWidth, "px"),
          margin: "".concat(size.margin, "px"),
          resize: resizable ? resizable : "none",
          direction: alignHorizontal === "left" ? "ltr" : "rtl"
        })
      }, this.renderCanvasComponent());
    }
  }]);
  return MiniMapComponent;
}(React.Component);
exports.MiniMapComponent = MiniMapComponent;
MiniMapComponent.defaultProps = {
  alignHorizontal: "right",
  startingWidth: 120,
  resizable: "none",
  verticalHeight: "div"
};